(function() {
  'use strict';
  function initMobileSwipe() {
    var mobileGallery = document.querySelector('.product__media-container.below-mobile .product__media');
    if (!mobileGallery) return;
    var startX = 0, startY = 0, distX = 0, distY = 0;
    var threshold = 50;
    var restraint = 100;
    function getMediaItems() {
      return Array.from(mobileGallery.querySelectorAll('.product__media-item'));
    }
    function getCurrentIndex() {
      var items = getMediaItems();
      return items.findIndex(function(item) { return !item.classList.contains('hidden'); });
    }
    function showItem(index) {
      var items = getMediaItems();
      if (index < 0 || index >= items.length) return;
      items.forEach(function(item) { item.classList.add('hidden'); });
      items[index].classList.remove('hidden');
      var mediaId = items[index].getAttribute('data-media-item-id');
      var container = mobileGallery.closest('.product__media-container');
      if (container && mediaId) {
        var thumbnails = container.querySelectorAll('.product-thumbnails__item');
        thumbnails.forEach(function(thumb) {
          thumb.classList.toggle('is-active', thumb.getAttribute('data-thumbnail-id') === mediaId);
        });
      }
    }
    mobileGallery.addEventListener('touchstart', function(e) {
      var touch = e.changedTouches[0];
      startX = touch.pageX;
      startY = touch.pageY;
    }, { passive: true });
    mobileGallery.addEventListener('touchend', function(e) {
      var touch = e.changedTouches[0];
      distX = touch.pageX - startX;
      distY = touch.pageY - startY;
      if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) {
        var currentIndex = getCurrentIndex();
        if (distX < 0) { showItem(currentIndex + 1); }
        else { showItem(currentIndex - 1); }
      }
    }, { passive: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileSwipe);
  } else {
    initMobileSwipe();
  }
})();
/* === Desktop Video Plyr Initialization + 1:1 Fill === */
(function() {
  function initDesktopVideoPlyr() {
    var container = document.querySelector(".product__media-container.above-mobile");
    if (!container) return;
    var videoItems = container.querySelectorAll("[data-media-type=\"video\"]");
    if (!videoItems.length) return;

    videoItems.forEach(function(item) {
      var video = item.querySelector("video");
      if (!video || video.closest(".plyr")) return;

      /* Make video fill 1:1 space */
      video.style.objectFit = "cover";
      video.style.width = "100%";
      video.style.height = "100%";

      if (typeof Shopify !== "undefined" && typeof Shopify.Plyr === "function") {
        new Shopify.Plyr(video, {
          controls: ["play-large", "play", "progress", "current-time", "mute", "volume", "fullscreen"],
          loop: { active: false },
          hideControls: true,
          clickToPlay: true
        });

        var plyrEl = video.closest(".plyr");
        if (plyrEl) {
          /* Prevent lightbox from intercepting clicks on video player */
          plyrEl.addEventListener("click", function(e) { e.stopPropagation(); }, true);

          /* Fill height for Plyr wrappers */
          plyrEl.style.height = "100%";
          var wrapper = plyrEl.querySelector(".plyr__video-wrapper");
          if (wrapper) wrapper.style.height = "100%";
        }
      }
    });
  }

  function waitForPlyrAndInit() {
    if (typeof Shopify !== "undefined" && typeof Shopify.Plyr === "function") {
      initDesktopVideoPlyr();
    } else {
      var attempts = 0;
      var interval = setInterval(function() {
        attempts++;
        if (typeof Shopify !== "undefined" && typeof Shopify.Plyr === "function") {
          clearInterval(interval);
          initDesktopVideoPlyr();
        } else if (attempts > 50) {
          clearInterval(interval);
        }
      }, 200);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", waitForPlyrAndInit);
  } else {
    waitForPlyrAndInit();
  }
})();

/* === Mobile PDP: Move star rating above product image === */
(function() {
  function moveStarRating() {
    if (window.innerWidth > 767) return;
    var header = document.querySelector(".show-on-mobile .product__block--product-header-inner");
    if (!header) return;
    if (header.querySelector(".mobile-star-rating")) return;
    var okeSr = document.querySelector(".product__meta .oke-sr");
    if (!okeSr) return;
    var wrapper = document.createElement("div");
    wrapper.className = "mobile-star-rating";
    var clone = okeSr.cloneNode(true);
    wrapper.appendChild(clone);
    header.appendChild(wrapper);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {
      moveStarRating();
      setTimeout(moveStarRating, 1000);
      setTimeout(moveStarRating, 2500);
    });
  } else {
    moveStarRating();
    setTimeout(moveStarRating, 1000);
    setTimeout(moveStarRating, 2500);
  }
})();

/* === Shop Pay installment block below both buttons === */
(function() {
  function createShopPayBlock() {
    if (document.querySelector(".custom-shop-pay-block")) return;
    var originalShopPay = document.querySelector(".product-form__shop-pay");
    if (!originalShopPay) return;

    /* Hide original */
    originalShopPay.style.display = "none";

    /* Find the insertion point: after the custom-liquid block, or after the form */
    var customBlock = document.querySelector(".product-block-custom-liquid");
    var form = document.querySelector(".product-form");
    var insertAfter = customBlock || form;
    if (!insertAfter) return;

    /* Clone the original shopify-payment-terms element */
    var payTerms = originalShopPay.querySelector("shopify-payment-terms");
    if (!payTerms) return;

    /* Create wrapper and clone */
    var spacer = document.createElement("div");
    spacer.style.cssText = "width:100%; height:12px; display:block; clear:both;";
    var wrapper = document.createElement("div");
    wrapper.className = "custom-shop-pay-block fs-body-75";
    wrapper.style.cssText = "width:100%; display:block; padding:16px; background:#f5f3ef; border-radius:4px;";
    var clone = payTerms.cloneNode(true);
    wrapper.appendChild(clone);

    /* Insert after the target element */
    insertAfter.parentNode.insertBefore(wrapper, insertAfter.nextSibling);
    insertAfter.parentNode.insertBefore(spacer, wrapper);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {
      setTimeout(createShopPayBlock, 800);
      setTimeout(createShopPayBlock, 2500);
    });
  } else {
    setTimeout(createShopPayBlock, 800);
    setTimeout(createShopPayBlock, 2500);
  }
})();

/* === PDP Video: autoplay muted when thumbnail is selected === */
(function() {
  function setupVideoAutoplay() {
    var mediaItems = document.querySelectorAll("[data-media-type=\"video\"]");
    if (!mediaItems.length) return;

    mediaItems.forEach(function(item) {
      var video = item.querySelector("video");
      if (!video) return;
      video.muted = true;
      video.setAttribute("muted", "");
      video.setAttribute("playsinline", "");

      /* MutationObserver for class/style changes indicating visibility */
      var observer = new MutationObserver(function() {
        var isActive = item.classList.contains("is-active") || item.classList.contains("swiper-slide-active") || item.classList.contains("product__media--active");
        if (isActive) {
          video.muted = true;
          video.play().catch(function() {});
        }
      });
      observer.observe(item, { attributes: true, attributeFilter: ["class", "style", "aria-hidden"] });
    });

    /* Listen on all thumbnail buttons */
    var allThumbs = document.querySelectorAll(".product-thumbnails__item, .product-thumbnails button, .product__media-toggle");
    allThumbs.forEach(function(thumb) {
      thumb.addEventListener("click", function() {
        setTimeout(function() {
          var activeVideo = document.querySelector("[data-media-type=\"video\"].is-active video, [data-media-type=\"video\"].product__media--active video, [data-media-type=\"video\"].swiper-slide-active video");
          if (!activeVideo) {
            document.querySelectorAll("[data-media-type=\"video\"] video").forEach(function(v) {
              if (v.offsetParent !== null && v.closest("[data-media-type]").offsetHeight > 100) {
                activeVideo = v;
              }
            });
          }
          if (activeVideo) {
            activeVideo.muted = true;
            activeVideo.play().catch(function() {});
          }
        }, 500);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() { setTimeout(setupVideoAutoplay, 1500); });
  } else {
    setTimeout(setupVideoAutoplay, 1500);
  }
})();

/* === Fix swatch images: try alt extensions if current 404s === */
(function() {
  function fixSwatchImages() {
    document.querySelectorAll(".product__color-swatch").forEach(function(sw) {
      var bg = window.getComputedStyle(sw).backgroundImage;
      if (bg === "none") return;
      var m = bg.match(/url\(["']?([^"'\)]+)["']?\)/);
      if (!m) return;
      var url = m[1];
      var img = new Image();
      img.onerror = function() {
        var base = url.replace(/_\d+x/g, "").replace(/\?.*$/, "");
        base = base.replace(/\.(png|jpg|jpeg|webp)$/i, "");
        [".jpg",".jpeg",".png",".webp"].forEach(function(ext) {
          var tryUrl = base + ext;
          var t = new Image();
          t.onload = function() {
            if (!sw.dataset.fixed) {
              sw.style.backgroundImage = "url(" + tryUrl + ")";
              sw.style.backgroundSize = "cover";
              sw.style.backgroundPosition = "center";
              sw.dataset.fixed = "1";
            }
          };
          t.src = tryUrl;
        });
      };
      img.src = url;
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() { setTimeout(fixSwatchImages, 800); });
  } else {
    setTimeout(fixSwatchImages, 800);
  }
})();

/* === Desktop Gallery: Prev/Next arrows on main product image === */
(function() {
  function initGalleryArrows() {
    var gallery = document.querySelector(".product__media-container.above-mobile[data-gallery-style=\"thumbnails\"]");
    if (!gallery || gallery.querySelector(".gallery-arrow")) return;

    var thumbButtons = document.querySelectorAll(".product-thumbnails__item-link");
    if (thumbButtons.length < 2) return;

    var currentIndex = 0;

    /* Find the currently active thumbnail index */
    function getActiveIndex() {
      for (var i = 0; i < thumbButtons.length; i++) {
        if (thumbButtons[i].classList.contains("active")) return i;
      }
      return 0;
    }

    /* Navigate to a specific index - direct DOM swap for speed */
    var mediaIds = [];
    gallery.querySelectorAll("[data-media-id]").forEach(function(m) {
      mediaIds.push(m.getAttribute("data-media-id"));
    });

    function goTo(idx) {
      if (idx < 0) idx = thumbButtons.length - 1;
      if (idx >= thumbButtons.length) idx = 0;
      currentIndex = idx;

      /* Get the target media ID from the thumbnail */
      var targetThumb = thumbButtons[idx].closest("[data-thumbnail-id]");
      var targetId = targetThumb ? targetThumb.getAttribute("data-thumbnail-id") : mediaIds[idx];

      /* Hide all media items, show the target */
      var mainMedia = gallery.querySelector(".product__media");
      if (!mainMedia) mainMedia = gallery;
      mainMedia.querySelectorAll(".product__media-item").forEach(function(item) {
        var media = item.querySelector("[data-media-id]");
        if (media) {
          if (media.getAttribute("data-media-id") === targetId) {
            item.classList.remove("hidden");
          } else {
            item.classList.add("hidden");
          }
        }
      });

      /* Update active thumbnail */
      thumbButtons.forEach(function(tb, i) {
        if (i === idx) tb.classList.add("active");
        else tb.classList.remove("active");
      });

      /* Autoplay video if the new media item contains one */
      var targetItem = mainMedia.querySelector(".product__media-item:not(.hidden) [data-media-type=\"video\"] video");
      if (targetItem) {
        targetItem.muted = true;
        targetItem.play().catch(function() {});
      }

      /* Pause any videos in hidden items */
      mainMedia.querySelectorAll(".product__media-item.hidden [data-media-type=\"video\"] video").forEach(function(v) {
        v.pause();
      });

      /* Reposition arrows for new image */
      if (typeof positionArrows === "function") setTimeout(positionArrows, 50);
    }

    /* Create arrow buttons */
    var prevBtn = document.createElement("button");
    prevBtn.className = "gallery-arrow gallery-arrow--prev";
    prevBtn.setAttribute("type", "button");
    prevBtn.setAttribute("aria-label", "Previous image");
    prevBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';

    var nextBtn = document.createElement("button");
    nextBtn.className = "gallery-arrow gallery-arrow--next";
    nextBtn.setAttribute("type", "button");
    nextBtn.setAttribute("aria-label", "Next image");
    nextBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';

    prevBtn.addEventListener("click", function(e) {
      e.stopPropagation();
      e.preventDefault();
      currentIndex = getActiveIndex();
      goTo(currentIndex - 1);
    });

    nextBtn.addEventListener("click", function(e) {
      e.stopPropagation();
      e.preventDefault();
      currentIndex = getActiveIndex();
      goTo(currentIndex + 1);
    });

    /* Append arrows to the main image area (not the thumbnail column) */
    var mainImageArea = gallery.querySelector(".product__media");
    if (!mainImageArea) mainImageArea = gallery;
    mainImageArea.style.position = "relative";
    mainImageArea.appendChild(prevBtn);
    mainImageArea.appendChild(nextBtn);

    /* Position arrows at the center of the actual visible image, not the container */
    function positionArrows() {
      var containerRect = mainImageArea.getBoundingClientRect();
      var visibleImg = null;
      var biggestH = 0;
      mainImageArea.querySelectorAll("img").forEach(function(img) {
        var r = img.getBoundingClientRect();
        if (r.height > biggestH) { biggestH = r.height; visibleImg = img; }
      });
      if (visibleImg && containerRect.height > 0) {
        var imgRect = visibleImg.getBoundingClientRect();
        var imgCenterInContainer = (imgRect.top + imgRect.height / 2) - containerRect.top;
        var pct = (imgCenterInContainer / containerRect.height * 100);
        prevBtn.style.top = pct + "%";
        nextBtn.style.top = pct + "%";
      }
    }
    positionArrows();
    /* Reposition on thumbnail click (image change) */
    thumbButtons.forEach(function(tb) {
      tb.addEventListener("click", function() { setTimeout(positionArrows, 300); });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() { setTimeout(initGalleryArrows, 1000); });
  } else {
    setTimeout(initGalleryArrows, 1000);
  }
})();